import { render } from "./Split.vue?vue&type=template&id=6ddaf57f&scoped=true"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"

import "./Split.vue?vue&type=style&index=0&id=6ddaf57f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddaf57f"]])

export default __exports__